"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _Font = _interopRequireDefault(require("./Font.config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Font = function Font(environment) {
  return (0, _styledComponents.css)(["@font-face{font-family:'Brandon Text';font-display:auto;font-weight:300;font-style:normal;src:url(", "/fonts/BrandonText-Light.otf);}@font-face{font-family:'Brandon Text';font-display:auto;font-weight:400;font-style:normal;src:url(", "/fonts/BrandonText-Regular.otf);}@font-face{font-family:'Brandon Text';font-display:auto;font-weight:700;font-style:normal;src:url(", "/fonts/BrandonText-Bold.otf);}"], _Font.default.cdnBaseUrl[environment], _Font.default.cdnBaseUrl[environment], _Font.default.cdnBaseUrl[environment]);
};

var _default = Font;
exports.default = _default;
module.exports = exports.default;